module.exports = __webpack_public_path__ + "img/texture_header.c18e00c7.jpg";